import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import {AccountCreationModule} from './account-creation.module'
import { environment } from '../../../environments/environment';

if (environment.production) {
  enableProdMode();
}


platformBrowserDynamic().bootstrapModule(AccountCreationModule)
  .catch(err => console.error(err));
